// Character Inspector Tool — break text into characters with Unicode details.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const charInspectorTool: Tool = {
  id: "char-inspector",
  name: () => m.ci_tool_name(),
  description: () => m.ci_tool_description(),
  icon: "🔣",
  basePath: "/char-inspector",
  status: "stable",
  tags: ["unicode", "character", "encoding", "developer"],
  pages: [
    {
      name: () => m.ci_nav_main(),
      path: "/char-inspector",
      description: () => m.ci_nav_main_desc(),
      icon: "🔣",
    },
  ],
};
